/*
 * Copyright (c) Vaisala Oyj. All rights reserved.
 */

import * as React from 'react';
import './CalibrationTableCardMobile.scss';
import { Size, Paper, Icon, Heading, Flex, BodyText, InputField, Select, Separator, Grid, Form, Toggle } from '@vaisala-rockhopper/components';
import { VaiIcon } from '@vaisala-rockhopper/design-tokens';
import { get_CCD_and_nD } from '../../../../modules/calculator/a-parameter-calculator/CalculatorFunctions';
import _ from 'lodash';
import { CalculationResultData } from '../pages/AParameterCalculator';

interface CalibrationTableCardMobileProps {
    onAParametersChange: (arg0: number[] | null) => void
    setGraphData:  (arg0: CalculationResultData | null) => void
    setGraphLabels: (arg0: number[]) => void
    setDiffValues: (arg0: number[]) => void
}

interface CalibrationTableRow {
    active: boolean,
    nd25: string,
    ccd: string,
    t: string,
    ndT: string,
    nd: string,
    diff: string
}

const CalibrationTableCardMobile = ({onAParametersChange, setGraphData, setGraphLabels, setDiffValues}: CalibrationTableCardMobileProps) => {

  const NdSelect = (props: any) => {

    const nd25Points = [
        1.300, 1.310, 1.320, 1.330, 1.340, 1.350, 1.360, 1.370, 1.380, 1.390,
        1.400, 1.410, 1.420, 1.430, 1.440, 1.450, 1.460, 1.470, 1.480, 1.490,
        1.500, 1.510, 1.520, 1.530, 1.540, 1.550, 1.560, 1.570, 1.580, 1.590,
        1.600, 1.610, 1.620, 1.630, 1.640, 1.650, 1.660, 1.670, 1.680, 1.690,
        1.700, 1.710, 1.720, 1.730, 1.740, 1.750];

    return (
        <Form.Item
            label={"nD@25"}
        >
            <Select
                placeholder="Select..."
                showSearch={true}
                width={Size.XS}
                value={calibrationValues[props.row].nd25}
                onChange={(e) => handleTableValueChange('nd25', e.toString(), props.row)}>
                {nd25Points.map((val, i) => {
                    return (
                        <Select.Option key={props.row + "_" + val} value={val}>{val}</Select.Option>
                    );
                })}
            </Select>
        </Form.Item>
    );

  }

//   const testnd25 = ["1.32", "1.33", "1.35","1.37", "1.40", "1.42", "1.45", "1.47", "1.50", "1.52"]
//   const testccd = ["86.85", "83.91", "77.96", "71.95", "62.58", "56.24", "46.30", "39.54", "28.88", "21.32"]
//   const testtemp = ["21.7","21.8","21.9","22.0","22.2","22.3","22.4","22.5","22.6","22.6"]

  const populateInitTableRows = () => {

    let tableRows: CalibrationTableRow[] = [];

    for (let i = 0; i < 10; i++) {
        let tableRow = {} as CalibrationTableRow;
        tableRow.active = true;
        tableRow.nd25 = "";
        tableRow.ccd = "";
        tableRow.t = "";
        tableRow.ndT = "";
        tableRow.nd = "";
        tableRow.diff = "";
        tableRows.push(tableRow)
    }
    return tableRows;
  }

  const [calibrationValues, setCalibrationValues] = React.useState<CalibrationTableRow[]>(populateInitTableRows())
  const [calibrationResults, setCalibrationResults] = React.useState<{'CCD': number[], 'nD': number[], 'nD_calc': number[], 'nD_calcLine': number[], 'A': number[], 'CCD_calc': number[]} | null>(null);
  const [diffs, setDiffs] = React.useState<{'meanDiff': string, 'maxDiff': string}>({'meanDiff': '', 'maxDiff': ''})
  const [hasDuplicateValues, setHasDuplicateValues] = React.useState(false);

  const handleActiveChange = (checked: boolean, idx: number) => {
    let calibrationValuesCopy = [...calibrationValues]

    calibrationValuesCopy[idx] = {
        ...calibrationValuesCopy[idx],
        "active": checked
    }

    setCalibrationValues(calibrationValuesCopy);
    calculateParameters(calibrationValuesCopy);
  }

  const handleTableValueChange = (name:string, value: string, idx: number) => {
    let calibrationValuesCopy = [...calibrationValues]

    calibrationValuesCopy[idx] = {
        ...calibrationValuesCopy[idx],
        [name]: value
    }

    calibrationValuesCopy = calibrationValuesCopy.sort((a: any,b: any) => a.nd25 - b.nd25);

    setCalibrationValues(calibrationValuesCopy)
    calculateParameters(calibrationValuesCopy);
    // console.log(calibrationValuesCopy, calibrationValuesCopy[idx])
  }

  const getDuplicates = (array: any[], key: string) => {
    return array.filter(e1=>{
      if(array.filter(e2=>{
        return e1[key] === e2[key];
      }).length > 1) {
        return e1;
      }
      return false;
    })
  }

  const calculateParameters = (newValues: CalibrationTableRow[]) => {
    let numberOfRefPoints = newValues;
    numberOfRefPoints = numberOfRefPoints.filter(el => el.active);
    const duplicates = getDuplicates(numberOfRefPoints, "nd25");
    if (numberOfRefPoints.length >= 5 && duplicates.length === 0) {
        let valueMissing = numberOfRefPoints.some(row => row['nd25'] === '' || row['ccd'] === '' || row['t'] === '' )
        if (!valueMissing) {
            let refpoints: number[] = [],
                CCDvalues: number[] = [],
                Tvalues: number[] = [];

            numberOfRefPoints.forEach((val, i) => {
                refpoints.push(parseFloat(val.nd25))
                CCDvalues.push(parseFloat(val.ccd))
                Tvalues.push(parseFloat(val.t))
            })
            let results = get_CCD_and_nD(refpoints, CCDvalues, Tvalues)
            if (results) {
                setGraphLabels(refpoints)
                setGraphData(results)
                setCalibrationResults(results)
                setHasDuplicateValues(false)
                // fillCalculationValues(results)
            }
        } else {
            setGraphLabels([])
            setGraphData(null)
            setCalibrationResults(null)
            onAParametersChange(null)
            setHasDuplicateValues(false)
        }
    } else {
        setGraphLabels([])
        setGraphData(null)
        setCalibrationResults(null)
        onAParametersChange(null)
        if (duplicates.length > 0) {
            setHasDuplicateValues(true)
        } else (
            setHasDuplicateValues(false)
        )
    }
  }

  React.useEffect(() => {
    let results = {...calibrationResults}
    let calibrationValuesCopy = [...calibrationValues]
    if (results !== undefined && calibrationValuesCopy !== undefined) {
        results.nD?.forEach((val: any, i: number) => {
            calibrationValuesCopy[i] = {
                ...calibrationValuesCopy[i],
                "ndT": results.nD![i].toFixed(4).toString(),
                "nd": results.nD_calc![i].toFixed(4).toString(),
                "diff": (results.nD_calc![i] - results.nD![i]).toFixed(4).toString()
            }
        })
        if (results.A !== undefined) {
            onAParametersChange(results.A)
        }
        setCalibrationValues(calibrationValuesCopy)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [calibrationResults])

  React.useEffect(() => {
    if (calibrationResults !== null) {
        let calibrationValuesCopy = [...calibrationValues]
        calibrationValuesCopy = calibrationValuesCopy.filter(el => el.active);
        let allDiffs = calibrationValuesCopy.map(el => parseFloat(el.diff))
        let meanDiff = _.mean(allDiffs)
        let maxDiff = _.max(allDiffs)
        setDiffs({
            'meanDiff': _.round(meanDiff, 5).toString(),
            'maxDiff': _.round(maxDiff ? maxDiff : 0, 4).toString()
        })
        setDiffValues(allDiffs)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [calibrationValues])

  const FeedbackMessage = () => {
    if (calibrationResults === null && !hasDuplicateValues) {
        return (
            <BodyText>
                <Icon name={VaiIcon.AlertInfo} /> Enter values for at least 5 calibration points
            </BodyText>
        );
    } else if (hasDuplicateValues) {
        return (
            <BodyText className="warning-message">
                <Icon name={VaiIcon.AlertWarning} /> Multiple calibration points with same nd@25 value
            </BodyText>
        );
    } else {
        return (
            <BodyText>

            </BodyText>
        );
    }
  }

  const InputValues = (props: any) => {
    let data = props.data ?? null;
    let i = props.i ?? 0;
    return (
        <Grid.Col
            key={"col1"+i}
        >
            <NdSelect
                row={i}
            />
            <Form.Item
                label={"CCD"}
            >
                <InputField
                    name={"ccd"}
                    value={data.ccd ?? ""}
                    disabled={!data.active}
                    width={Size.XS}
                    onChange={e =>
                        {
                            handleTableValueChange(e.target.name, e.target.value, i)
                        }
                    }
                    placeholder={"-"}
                />
            </Form.Item>
            <Form.Item
                label={"T (°C)"}
            >
                <InputField
                    name={"t"}
                    value={data.t ?? ""}
                    disabled={!data.active}
                    width={Size.XS}
                    onChange={e =>
                        {
                            handleTableValueChange(e.target.name, e.target.value, i)
                        }
                    }
                    placeholder={"-"}
                />
            </Form.Item>
        </Grid.Col>
    )
  }

  return (
    <Paper className="calibration-table-card-mobile">
        <Flex
            alignContent="stretch"
            justifyContent="space-between"
            flexDirection="row"
            flexWrap="nowrap"
            alignItems="stretch"
        >
            <Heading level={1}>Calibration Points</Heading>
        </Flex>

        <Grid className="calibration-points-list">
            <Form>
                {calibrationValues.map((data, i)=> (
                    <div key={'row__container-' + i}>
                        <Grid.Row key={'row'+i}>
                            <InputValues
                                data={data}
                                i={i}
                            />
                            <Grid.Col
                                key={"col2"+i}
                            >
                                <Toggle
                                    onChange={nextValue => handleActiveChange(nextValue, i)}
                                    checked={data.active}
                                    text={""}
                                />
                                <div className="calculated-values">
                                    <div>
                                        <BodyText><small>nD(T)</small>{data.ndT !== "" ? data.ndT : "-"}</BodyText>
                                    </div>
                                    <div>
                                        <BodyText><small>nD</small>{data.nd !== "" ? data.nd : "-"}</BodyText>
                                    </div>
                                    <div>
                                        <BodyText className={Math.abs(parseFloat(data.diff)) < 0.0004 ? "data-diff-pass" : "data-diff-fail"}>
                                            <small>Diff</small>
                                            {data.diff !== "" ? (parseFloat(data.diff) > 0) ? "+" + data.diff : data.diff : "-"}
                                            {Math.abs(parseFloat(data.diff)) >= 0.0004 &&
                                                <Icon name={VaiIcon.AlertWarning} />
                                            }
                                        </BodyText>
                                    </div>
                                </div>
                            </Grid.Col>
                        </Grid.Row>
                        <Separator/>
                    </div>
                ))}
            </Form>
        </Grid>

        <Flex
            className="calibration-table-footer"
            alignContent="stretch"
            justifyContent="space-between"
            flexDirection="row"
            flexWrap="nowrap"
            alignItems="stretch"
        >
            <FeedbackMessage />
            <div className="diffs-container">
                <div

                    className="diff-container"
                >
                    <BodyText>Mean diff</BodyText>
                    <BodyText className={Math.abs(parseFloat(diffs.maxDiff)) < 0.0004 ? "data-diff-pass" : "data-diff-fail"}>
                        {diffs.meanDiff !== "" ? (parseFloat(diffs.meanDiff) > 0) ? "+" + diffs.meanDiff : diffs.meanDiff : "-"}
                        {Math.abs(parseFloat(diffs.meanDiff)) >= 0.0004 &&
                            <Icon name={VaiIcon.AlertWarning} />
                        }
                    </BodyText>
                </div>
                <div
                    className="diff-container"
                >
                    <BodyText>Max diff</BodyText>
                    <BodyText className={Math.abs(parseFloat(diffs.maxDiff)) < 0.0004 ? "data-diff-pass" : "data-diff-fail"}>
                        {diffs.maxDiff !== "" ? (parseFloat(diffs.maxDiff) > 0) ? "+" + diffs.maxDiff : diffs.maxDiff : "-"}
                        {Math.abs(parseFloat(diffs.maxDiff)) >= 0.0004 &&
                            <Icon name={VaiIcon.AlertWarning} />
                        }
                    </BodyText>
                </div>
            </div>
        </Flex>

    </Paper>
  );
};
export default CalibrationTableCardMobile;
